// ProtectedRoutes.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Loader from "../components/loader";
import { useUser } from "../context/userContext";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { userData, loading } = useUser();

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", height: "100vh" }}>
        <Loader label={"Cargando..."} />
      </div>
    );
  }

  if (!userData || !userData.role) {
    return <Navigate to="/signin" state={{ location }} />;
  }

  const allowedRoutesForRole = {
    user: [
      "/", "/signin", "/menuestudiante", "/menuestudiante/libros/", "/perfil",
      "/misprestamos", "/menuestudiante/autores/"
    ],
    biblioteca: ["/", "/signin", "/menubiblioteca", "/perfil"],
  };

  const userRole = userData.role;
  const allowedRoutes = allowedRoutesForRole[userRole] ?? [];
  const isAllowed = allowedRoutes.some((allowed) =>
    location.pathname === allowed || location.pathname.startsWith(allowed + "/")
  );

  if (!isAllowed) {
    return <Navigate to={userRole === "user" ? "/menuestudiante" : "/menubiblioteca"} />;
  }

  return children;
};

export default ProtectedRoute;
